export enum ENotificationType {
  NEW_EVENT = 'NEW_EVENT',
  NEW_RECURRING_EVENT = 'NEW_RECURRING_EVENT',
  EVENT_UPDATE = 'EVENT_UPDATE',
  NEW_POST = 'NEW_POST',
  NEW_TICKET = 'NEW_TICKET',
  TICKET_UPDATE = 'TICKET_UPDATE',
  NEW_DELIVERABLE = 'NEW_DELIVERABLE',
  DELIVERABLE_MESSAGE_CREATED = 'DELIVERABLE_MESSAGE_CREATED',
  DELIVERABLE_CORRECTED = 'DELIVERABLE_CORRECTED',
  NEW_TUTOR = 'NEW_TUTOR',
  NEW_TUTORING_GROUP_MEMBER = 'NEW_TUTORING_GROUP_MEMBER',
  NEW_TEACHER_ACTIVITY = 'NEW_TEACHER_ACTIVITY',
  NEW_TEACHER_QUIZ = 'NEW_TEACHER_QUIZ',
  NEW_EXAM_GROUP = 'NEW_EXAM_GROUP',
  NEW_EXAM_GROUP_EXAM = 'NEW_EXAM_GROUP_EXAM',
  NEW_LIVERECORD = 'NEW_LIVERECORD',
  TASK_RESOURCE_UPLOADED = 'TASK_RESOURCE_UPLOADED',
  TASK_REJECTED = 'TASK_REJECTED',
  TASK_APPROVED = 'TASK_APPROVED',
  NEW_STUDENT_VOTE = 'NEW_STUDENT_VOTE',
  EXAM_GROUP_REGISTRATION_PERIOD_DEADLINE_3_DAYS = 'EXAM_GROUP_REGISTRATION_PERIOD_DEADLINE_3_DAYS',
  EXAM_GROUP_PROVISIONAL_LIST_PUBLISHED = 'EXAM_GROUP_PROVISIONAL_LIST_PUBLISHED',
  EXAM_GROUP_FINAL_LIST_PUBLISHED = 'EXAM_GROUP_FINAL_LIST_PUBLISHED',
  EXAM_GROUP_EXAM_DATE_PUBLISHED = 'EXAM_GROUP_EXAM_DATE_PUBLISHED',
  EXAM_GROUP_EXAM_IN_PROGRESS = 'EXAM_GROUP_EXAM_IN_PROGRESS',
  EXAM_GROUP_PUBLISH_NOTES = 'EXAM_GROUP_PUBLISH_NOTES',
  EXAM_GROUP_IN_COMPETITION_PHASE = 'EXAM_GROUP_IN_COMPETITION_PHASE',
  ACTIVITY_CONTENT_UPDATED = 'ACTIVITY_CONTENT_UPDATED'
}

export enum ENotificationFilterCategory {
  ALL = 'ALL',
  EVENTS = 'EVENTS',
  POSTS = 'POSTS',
  TICKETS = 'TICKETS'
}

export const NOTIFICATION_CATEGORY_TYPES: Record<
  ENotificationFilterCategory,
  ENotificationType[] | undefined
> = {
  [ENotificationFilterCategory.ALL]: undefined,
  [ENotificationFilterCategory.EVENTS]: [
    ENotificationType.NEW_EVENT,
    ENotificationType.NEW_RECURRING_EVENT,
    ENotificationType.EVENT_UPDATE
  ],
  [ENotificationFilterCategory.POSTS]: [ENotificationType.NEW_POST],
  [ENotificationFilterCategory.TICKETS]: [
    ENotificationType.NEW_TICKET,
    ENotificationType.TICKET_UPDATE
  ]
};
